import { CountriesApi, CountryResponse } from '@oncampusabroad/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialApiState, ApiCallBase, createApiConfiguration } from './apiConfiguration';


interface CountriesCall extends ApiCallBase {
  response: CountryResponse[];
}

interface State {
  countries: CountriesCall;
}

const initialState: State = {
  countries: initialApiState,
};


export const fetchCountries = createAsyncThunk(
  'countries/fetchCountries',
  async () => {
    try {
      const countriesApi = new CountriesApi(createApiConfiguration());
      
      const response = await countriesApi.getCountries();
      return response.data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw error;
    }
  }
);

const CountriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {
    resetCountries: (state) => {
      state.countries = {
        ...initialApiState,
        response: state.countries.response,
      };
    },
    resetCountriesResponse: (state) => {
      state.countries = {
        ...initialApiState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCountries.pending, (state) => {
      state.countries.loading = 'pending';
    });
    builder.addCase(fetchCountries.fulfilled, (state, action) => {
      state.countries.loading = 'succeeded';
      state.countries.response = action.payload;
    });
    builder.addCase(fetchCountries.rejected, (state, action) => {
      state.countries.loading = 'failed';
      state.countries.error = action.payload;
    });
  },
});

export const {
  resetCountries,
  resetCountriesResponse,
} = CountriesSlice.actions;

export default CountriesSlice.reducer; 